var exports = {
  "n": "x28a7bf27--c964f9--sub-header",
};

module.exports = exports;
